import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconsEnum, IconSize } from '@/shared/enums';
import { NgClass } from '@angular/common';

@Component({
  selector: 'bevvi-icon',
  imports: [NgClass],
  templateUrl: './icon.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Icon {
  public readonly icon = input.required<IconsEnum>();
  public readonly label = input<string>('');
  public readonly size = input<IconSize>(IconSize.MD);
  public readonly className = input<string>('');

  protected readonly iconClasses = computed(() => {
    const sizeMap: Record<IconSize, string> = {
      [IconSize.XS]: 'size-3 min-w-3 min-h-3',
      [IconSize.SM]: 'size-4 min-w-4 min-h-4',
      [IconSize.MD]: 'size-5 min-w-5 min-h-5',
      [IconSize.LG]: 'size-6 min-w-6 min-h-6',
      [IconSize.XL]: 'size-8 min-w-8 min-h-8',
    };

    return `
      inline-block
      fill-current
      text-inherit
      ${sizeMap[this.size()]}
      ${this.className()}
    `;
  });

  protected readonly href = computed(() => `/sprite.svg#${this.icon()}`);
}
